export default __webpack_public_path__ + "static/media/video-off.ab759eb4.svg";